import { ValidationInputType } from "@generation/core";
import { translate } from "../Locales/translator";
import { AbstractValidation } from "./AbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { isFileManagementField } from "./isFileManagementField";

export class IsRequiredValidation extends AbstractValidation {
  key = "isRequired";

  constructor(public readonly dependsOn: boolean = false, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    const anyValue = value as any;
    if (isFileManagementField(anyValue)) {
      return anyValue.files.filter((file) => !file.deleted).length > 0;
    }
    if (typeof value !== "string" && value) {
      return value.length > 0;
    }

    return value !== undefined && value !== null && value !== "";
  };

  defaultMessage = (label: string): string =>
    translate("Generation_Form_{label}IsVerplicht", { label: label });
}
